export const APP_PERMISSIONS: any = {
  dataSourceInstance: {
    items: [
      { fqn: 'pipeline:dataSources:items:view', name: 'view', default: true },
      { fqn: 'pipeline:dataSources:items:upload', name: 'upload' },
      { fqn: 'pipeline:dataSources:items:delete', name: 'delete' },
      { fqn: 'pipeline:dataSources:ingestion:run', name: 'ingestion.execute' },
    ],
    configuration: [
      { fqn: 'pipeline:dataSources:configuration:view', name: 'view', default: true },
      { fqn: 'pipeline:dataSources:update', name: 'update' },
      { fqn: 'pipeline:dataSources:delete', name: 'remove' },
    ],
    accessControl: [
      { fqn: 'pipeline:dataSources:accessControl:view', name: 'view', default: true },
      { fqn: 'pipeline:dataSources:accessControl:manage', name: 'manage' },
    ],
    usageStats: [{ fqn: 'pipeline:dataSources:usageStats:view', name: 'view', default: true }],
    auditTrail: [{ fqn: 'pipeline:dataSources:auditTrail:view', name: 'view', default: true }],
  },

  agentInstance: {
    items: [{ fqn: 'pipeline:agents:items:view', name: 'view', default: true }],
    configuration: [
      { fqn: 'pipeline:agents:configuration:view', name: 'view', default: true },
      { fqn: 'pipeline:agents:update', name: 'update' },
      { fqn: 'pipeline:agents:execute', name: 'execute' },
      { fqn: 'pipeline:agents:delete', name: 'remove' },
    ],
    accessControl: [
      { fqn: 'pipeline:agents:accessControl:view', name: 'view', default: true },
      { fqn: 'pipeline:agents:accessControl:manage', name: 'manage' },
    ],
    usageStats: [{ fqn: 'pipeline:agents:usageStats:view', name: 'view', default: true }],
    auditTrail: [{ fqn: 'pipeline:agents:auditTrail:view', name: 'view', default: true }],
  },

  userAppInstance: {
    conversation: [
      { fqn: 'pipeline:apps:conversation:view', name: 'view', default: true },
      { fqn: 'pipeline:apps:conversation:create', name: 'create', default: true },
      { fqn: 'pipeline:apps:conversation:delete', name: 'delete', default: true },
    ],
    dataSources: [
      { fqn: 'pipeline:apps:dataSources:view', name: 'view', default: true },
      { fqn: 'pipeline:apps:dataSources:documents:view', name: 'documents.view', default: true },
      { fqn: 'pipeline:apps:dataSources:ingestion:run', name: 'ingestion.execute' },
    ],
    configuration: [
      { fqn: 'pipeline:apps:configuration:view', name: 'view', default: true },
      { fqn: 'pipeline:apps:configuration:update', name: 'update' },
      { fqn: 'pipeline:apps:delete', name: 'remove' },
    ],
    accessControl: [
      { fqn: 'pipeline:apps:accessControl:view', name: 'view', default: true },
      { fqn: 'pipeline:apps:accessControl:manage', name: 'manage' },
    ],
    usageStats: [{ fqn: 'pipeline:apps:usageStats:view', name: 'view', default: true }],
    auditTrail: [{ fqn: 'pipeline:apps:auditTrail:view', name: 'view', default: true }],
  },

  pipelineInstance: {
    pipeline: [
      { fqn: 'pipeline:view', name: 'view', default: true },
      { fqn: 'pipeline:execute', name: 'execute' },
      { fqn: 'pipeline:delete', name: 'remove' },
    ],
    configuration: [
      { fqn: 'pipeline:configuration:view', name: 'view', default: true },
    ],
    accessControl: [
      { fqn: 'pipeline:accessControl:view', name: 'view', default: true },
      { fqn: 'pipeline:accessControl:manage', name: 'manage' },
    ],
    usageStats: [{ fqn: 'pipeline:usageStats:view', name: 'view', default: true }],
    auditTrail: [{ fqn: 'pipeline:auditTrail:view', name: 'view', default: true }],
  },
};
